/**
 * Cardmarket (the EU, the EEA, GB and CH) links. NOT an affiliate link: the
 * referral program needs an account, which needs an address in a supported
 * country (plan 2026-10-04, section 2). The per-card link is the store's
 * search for the English name exactly as the deck spells it; phase 0 checked
 * Sol Ring, Rhystic Study, Fable of the Mirror-Breaker and Fire // Ice.
 *
 * Built here, never taken from Scryfall's purchase_uris, which carry
 * referrer=scryfall. The /en/ path is the store's default language.
 */

const CARDMARKET_SEARCH = 'https://www.cardmarket.com/en/Magic/Products/Search?searchString='

/** The list-import page (phase 0, Keith 2026-10-04): a Wants list that takes
 *  a pasted list with one card per line. */
export const CARDMARKET_LIST_URL = 'https://www.cardmarket.com/en/Magic/Wants'

export function cardmarketCardUrl(cardName: string): string {
  return CARDMARKET_SEARCH + encodeURIComponent(cardName.trim())
}
